module.exports = __webpack_public_path__ + "media/images/location-502d09fada019cb095640206ff3a4200.png";